// 신청 3단계 스텝퍼 (시안 .stp) — 1 입력 방식 · 2 차량 정보 · 3 검차 위치.
// 링크 모드·첨부 화면은 스텝퍼가 없다(호출 측이 렌더하지 않음).
import React from 'react';
import { T, R, FONT } from '../../../theme';

var wrap = { display: 'flex', flexDirection: 'column', gap: 6 };
var dots = { display: 'flex', alignItems: 'center', gap: 6 };
var dot = { width: 24, height: 24, borderRadius: R.pill, flex: 'none', display: 'grid', placeItems: 'center',
  fontSize: 11.5, fontWeight: 800, fontVariantNumeric: 'tabular-nums' };
var bar = { flex: 1, height: 2, background: T.line };
var labs = { display: 'flex', gap: 6 };
var lab = { flex: 1, fontSize: FONT.label, fontWeight: 700, color: T.faint, textAlign: 'center', minWidth: 0 };

var KEYS = ['simpleStepMethod', 'simpleStepVehicle', 'simpleStepLocation'];

function RequestStepper(props) {
  var t = props.t;
  var step = props.step;
  return (<div style={wrap} data-testid="req-stepper" data-step={step}>
    <div style={dots}>
      {[1, 2, 3].map(function (n) {
        var done = n < step;
        var on = n === step;
        var tone = done ? { background: T.ok, color: T.card, border: '1px solid ' + T.ok }
          : on ? { background: T.navy, color: T.card, border: '1px solid ' + T.navy }
            : { background: T.card, color: T.faint, border: '1px solid ' + T.bd };
        return (<React.Fragment key={n}>
          {n > 1 ? <span style={Object.assign({}, bar, n <= step ? { background: T.ok } : null)} /> : null}
          <span style={Object.assign({}, dot, tone)}>{n}</span>
        </React.Fragment>);
      })}
    </div>
    <div style={labs}>
      {KEYS.map(function (k, i) {
        var on = i + 1 === step;
        return <span key={k} style={Object.assign({}, lab, on ? { color: T.navy } : null)}>{t(k)}</span>;
      })}
    </div>
  </div>);
}

export default RequestStepper;
